import type { Agent } from 'src/data/models/agent.model';
import type { Pagination } from 'src/data/models/pagination.model';
import { FetchHttpClient } from '../config/fetch';
import type { IHttpClient } from '../config/http-client.interface';

const AgentRemoteData = (client: IHttpClient) => ({
  getAgents: async (p?: {
    limit?: number;
    skip?: number;
    cityName?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<Pagination<Agent>> => {
    const response = await client.get({
      path: '/v1/public/agents',
      queryParams: {
        limit: p?.limit,
        skip: p?.skip,
        province_name: p?.cityName,
        search: p?.search,
        sortBy: p?.sortBy,
        sortOrder: p?.sortOrder,
      },
    });
    return response;
  },
  getAgentById: async (id: string): Promise<Agent> => {
    const response = await client.get({
      path: `/v1/public/agents/${id}`,
    });
    return response;
  },
});

export const agentRemotedata = AgentRemoteData(FetchHttpClient);
